import { DestinationGeoTypeEnum } from 'typings/destinations/DestinationGeoTypeEnum';

export const DestinationGeoType = {
    COUNTRY: 0,
    PLACE: 1,
} as const;

const validGeoTypes = new Set<number>(Object.values(DestinationGeoType));

/**
 * Type guard to check if a value is a valid DestinationGeoTypeEnum.
 */
export function isValidGeoType(
    value: unknown,
): value is DestinationGeoTypeEnum {
    return typeof value === 'number' && validGeoTypes.has(value);
}

/**
 * Parses and validates a geo type value.
 * Returns the default geo type if value is null/undefined/empty.
 * Throws an error if the value is invalid.
 */
export function parseGeoType(
    value: string | null | undefined,
    defaultGeoType: DestinationGeoTypeEnum = DestinationGeoType.PLACE,
): DestinationGeoTypeEnum {
    if (value === null || value === undefined || value === '') {
        return defaultGeoType;
    }

    const numValue = Number(value);

    if (!isValidGeoType(numValue)) {
        throw new Error(
            `Invalid geo_type: ${value}. Expected one of: ${Object.entries(
                DestinationGeoType,
            )
                .map(([key, val]) => `${val} (${key})`)
                .join(', ')}`,
        );
    }

    return numValue;
}
